module.exports = __webpack_public_path__ + "img/171.2c0ba1b6.jpg";